import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
		(function (C, A, L) { let p = function (a, ar) { a.q.push(ar); }; let d = C.document; C.Cal = C.Cal || function () { let cal = C.Cal; let ar = arguments; if (!cal.loaded) { cal.ns = {}; cal.q = cal.q || []; d.head.appendChild(d.createElement("script")).src = A; cal.loaded = true; } if (ar[0] === L) { const api = function () { p(api, arguments); }; const namespace = ar[1]; api.q = api.q || []; typeof namespace === "string" ? (cal.ns[namespace] = api) && p(api, ar) : p(cal, ar); return; } p(cal, ar); }; })(window, "https://app.cal.com/embed/embed.js", "init");
		Cal("init", "30min", {origin:"https://cal.com"});
		 
		  // Important: Please add the following attributes to the element that should trigger the calendar to open upon clicking.
		  // `data-cal-link="vendredisociety/30min"`
		  // data-cal-namespace="30min"
		  // `data-cal-config='{"layout":"month_view"}'`
		  
		  Cal.ns["30min"]("ui", {"styles":{"branding":{"brandColor":"#f0ff3D"}},"hideEventTypeDetails":false,"layout":"month_view"});
		
	}

	onClick() {
		// console.log('click');
	}
}
